// extracted by mini-css-extract-plugin
export default {"brass-grid-button":"CommandCell_brass-grid-button__4ETs+"};